import { useRouter } from 'next/router';

import { CollectionHelpers } from 'src/helpers/CollectionHelpers';
import useSWR from 'swr';
import useSWRImmutable from 'swr/immutable';

import { Team } from 'models';

import { useCurrentUser } from 'hooks/use-current-user';
import { TeamService } from 'services/TeamService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

const useTeam = (team: CollectionOrId<Team> | undefined) => {
    const user = useCurrentUser();
    const teamId = team && CollectionHelpers.id(team);

    const swr = useSWR<Team>(
        ...prepareConditionalSwrArgs({
            key: `/api/teams/${teamId}`,
            fetcher: () => TeamService.get(teamId!),
            condition: Boolean(user) && Boolean(teamId),
        }),
    );

    return { ...swr, team: swr.data || null };
};

const useTeamName = (teamId: string | undefined) => {
    const swr = useSWRImmutable<string>(
        ...prepareConditionalSwrArgs({
            key: `/api/team-name/${teamId}`,
            fetcher: () => TeamService.getName(teamId!),
            condition: Boolean(teamId),
        }),
    );

    return { ...swr, teamName: swr.data || null };
};

const useTeamFromURL = () => {
    const { query } = useRouter();

    const { team } = query as { team: string | undefined };

    return useTeam(team);
};

export { useTeam, useTeamFromURL, useTeamName };
